import commonUtil from '../../utils/commonUtil';

export const GET_LOAD_STORE_STATES = 'GET_LOAD_STORE_STATES';
export const GET_STORE_STATES_SUCCESS = 'GET_STORE_STATES_SUCCESS';
export const GET_STORE_STATES_LOAD_FAIL = 'GET_STORE_STATES_LOAD_FAIL';

export const GET_NEAR_BY_STORE_LOADED = 'GET_NEAR_BY_STORE_LOADED';
export const GET_NEAR_BY_STORE_SUCCESS = 'GET_NEAR_BY_STORE_SUCCESS';
export const GET_NEAR_BY_STORE_FAIL = 'GET_NEAR_BY_STORE_FAIL';

export const SET_NEAR_BY_STORE_LOADED = 'SET_NEAR_BY_STORE_LOADED';
export const SET_NEAR_BY_STORE_SUCCESS = 'SET_NEAR_BY_STORE_SUCCESS';
export const SET_NEAR_BY_STORE_FAIL = 'SET_NEAR_BY_STORE_FAIL';

export const GET_FAVORITE_STORE_LOADED = 'GET_FAVORITE_STORE_LOADED';
export const GET_FAVORITE_STORE_SUCCESS = 'GET_FAVORITE_STORE_SUCCESS';
export const GET_FAVORITE_STORE_FAIL = 'GET_FAVORITE_STORE_FAIL';

export const GET_NEAR_BY_USER_LOC_LOADED = 'GET_NEAR_BY_USER_LOC_LOADED';
export const GET_NEAR_USER_LOC_SUCCESS = 'GET_NEAR_USER_LOC_SUCCESS';
export const GET_NEAR_USER_LO_FAIL = 'GET_NEAR_USER_LO_FAIL';

export const CLEAN_DATA_STORE_LOCATION = 'CLEAN_DATA_STORE_LOCATION';


export function getStoreLocation() {
  const userEnteredData = {};
  userEnteredData.brand = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();

  return {
    types: [GET_LOAD_STORE_STATES, GET_STORE_STATES_SUCCESS, GET_STORE_STATES_LOAD_FAIL],
    promise: client => client.post('/api/storeLocation/stateSearch', {
      data: (userEnteredData),
    }),
  };
}

export function getNearByStores(zipOrState) {
  const userEnteredData = {};
  userEnteredData.brand = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();

  if (!isNaN(zipOrState)) {
    userEnteredData.zipCode = zipOrState.toString();
    userEnteredData.dataCenter = 'SiteA';
  } else {
    userEnteredData.storeOrCityOrStateName = zipOrState;
  }

  const URL = userEnteredData.zipCode ? '/api/currentUser/nearByStores' : '/api/currentUser/getStoreList';

  return {
    types: [GET_NEAR_BY_STORE_LOADED, GET_NEAR_BY_STORE_SUCCESS, GET_NEAR_BY_STORE_FAIL],
    promise: client => client.post(URL, {
      data: (userEnteredData),
    }),
  };
}

export function getFavoriteStore() {
  const userEnteredData = {};
  userEnteredData.brand = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();

  return {
    types: [GET_FAVORITE_STORE_LOADED, GET_FAVORITE_STORE_SUCCESS, GET_FAVORITE_STORE_FAIL],
    promise: client => client.post('/api/currentUser/getFavoriteStore', {
      data: (userEnteredData),
    }),
  };
}

export function saveNearByStores(storeId) {
  const userEnteredData = {};
  userEnteredData.brand = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();
  userEnteredData.favoriteStoreId = storeId;

  return {
    types: [SET_NEAR_BY_STORE_LOADED, SET_NEAR_BY_STORE_SUCCESS, SET_NEAR_BY_STORE_FAIL],
    promise: client => client.post('/api/currentUser/favoriteStore', {
      data: (userEnteredData),
    }),
  };
}

export function getStoresByUserLocation({ queryParam }) {
  const { lat, lng } = queryParam;
  const userEnteredData = {};
  userEnteredData.brand = commonUtil.getBrand().toUpperCase();
  userEnteredData.channel = commonUtil.getChannel().toUpperCase();
  userEnteredData.lat = lat;
  userEnteredData.lng = lng;

  return {
    types: [GET_NEAR_BY_USER_LOC_LOADED, GET_NEAR_USER_LOC_SUCCESS, GET_NEAR_USER_LO_FAIL],
    promise: client => client.post(`/api/getNearStores?latlng=${lat},${lng}`, {
      data: (userEnteredData),
    }),
  };
}

export function cleanDataStoreLocation() {
  return {
    type: CLEAN_DATA_STORE_LOCATION,
  };
}
